<template>
  <div class="">
    <md-card class="md-layout-item">
      <md-card-header>
        <div class="md-title">Endereço</div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field :class="getValidationClass('cidadeId')">
              <label for="cidade">Cidade</label>
              <md-select v-if="!readOnly" v-model="form.cidadeId">
                <md-option
                  v-for="cidade in cidades"
                  :key="cidade.id"
                  :value="cidade.id"
                >
                  {{ cidade.nome }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-field :class="getValidationClass('estado')">
              <label for="estado">Estado</label>
              <md-select
                v-if="!readOnly"
                v-model="form.estado"
                @md-selected="buscaEstado"
              >
                <md-option
                  v-for="estado in estados"
                  :key="estado"
                  :value="estado"
                >
                  {{ estado }}
                </md-option>
              </md-select>
            </md-field>
            <span v-if="!$v.form.estado.required" class="md-error"
              >Estado é obrigatório</span
            >
          </div>
        </div>

        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-5x">
            <md-field :class="getValidationClass('cep')">
              <label for="cep">CEP</label>
              <md-input
                id="cep"
                v-model="form.cep"
                v-mask="'#####-###'"
                :readonly="readOnly"
              />
              <span v-if="cepError.has" class="md-error">{{
                cepError.message
              }}</span>
              <span v-if="!$v.form.cep.required" class="md-error"
                >CEP é obrigatório</span
              >
            </md-field>
          </div>
          <div class="md-layout-item">
            <div>
              <md-button
                v-if="!buscandoCep"
                class="md-raised md-primary"
                @click="buscaCep"
              >
                Buscar CEP
              </md-button>
              <md-progress-spinner
                v-if="buscandoCep"
                :md-diameter="30"
                :md-stroke="3"
                md-mode="indeterminate"
              />
            </div>
          </div>
        </div>

        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field :class="getValidationClass('bairro')">
              <label for="bairro">Bairro</label>
              <md-input
                id="bairro"
                v-model="form.bairro"
                :readonly="readOnly"
              />
              <span v-if="!$v.form.bairro.required" class="md-error"
                >Bairro é obrigatório</span
              >
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-field :class="getValidationClass('logradouro')">
              <label for="logradouro">Logradouro</label>
              <md-input
                id="logradouro"
                v-model="form.logradouro"
                :readonly="readOnly"
              />
              <span v-if="!$v.form.logradouro.required" class="md-error"
                >Logradouro é obrigatório</span
              >
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-field :class="getValidationClass('numero')">
              <label for="numero">Número</label>
              <md-input
                id="numero"
                v-model="form.numero"
                v-mask="'####'"
                :readonly="readOnly"
              />
              <span v-if="!$v.form.numero.required" class="md-error"
                >Numero é obrigatório</span
              >
            </md-field>
          </div>
        </div>

        <div class="md-layout-item">
          <md-field :class="getValidationClass('complemento')">
            <label for="complemento">Complemento</label>
            <md-textarea
              id="complemento"
              v-model="form.complemento"
              :readonly="readOnly"
            />
          </md-field>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import cepPromise from 'cep-promise'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import http from '../utils/http'

export default {
  name: 'Endereco',
  directives: {},
  mixins: [validationMixin],
  props: {
    cidade: {
      cidadeId: String,
      ibgeId: String,
      nome: String,
    },
    estado: String,
    cep: String,
    bairro: String,
    logradouro: String,
    numero: String,
    complemento: String,
    readOnly: Boolean,
  },
  data() {
    return {
      form: {
        cidade: null,
        cidadeId: null,
        estado: 'MT',
        cep: '',
        bairro: null,
        logradouro: null,
        numero: null,
        complemento: null,
      },
      buscandoCep: false,
      cepError: {
        has: false,
        message: null,
      },
      cidades: [],
      estados: [
        'AC',
        'AL',
        'AM',
        'AP',
        'BH',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MG',
        'MS',
        'MT',
        'PA',
        'PB',
        'PE',
        'PI',
        'PR',
        'RJ',
        'RN',
        'RO',
        'RR',
        'RS',
        'SC',
        'SE',
        'SP',
        'TO',
      ],
    }
  },
  validations: {
    form: {
      cidadeId: { required },
      estado: { required },
      cep: { required },
      bairro: { required },
      logradouro: { required },
      numero: { required },
    },
  },
  async mounted() {
    this.form = {
      cidadeId: this.cidade ? this.cidade.id : null,
      cidade: this.cidade ? this.cidade.nome : '',
      estado: 'MT',
      cep: this.cep || '',
      bairro: this.bairro,
      logradouro: this.logradouro,
      numero: this.numero,
      complemento: this.complemento,
    }

    await this.buscaEstado(this.form.estado)
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    async buscaEstado(sigla) {
      const data = await http.get(`cidade/${sigla}`)
      this.cidades = data.cidades || []
    },
    async buscaCep() {
      const cep = this.form.cep.split('-').join('')
      this.buscandoCep = true
      if (this.form.cep.trim() !== '' && this.form.cep.length === 9) {
        try {
          const result = await cepPromise(cep)

          this.form.estado = result.state
          this.form.bairro = result.neighborhood
          this.form.logradouro = result.street
        } catch (err) {
          if (err.type === 'validation_error') {
            this.cepError = {
              has: true,
              message: err.errors[0].message,
            }
          } else {
            this.cepError = {
              has: true,
              message: 'CEP não encontrado',
            }
          }
        }
      }

      this.buscandoCep = false
    },
    async validaCep(cep) {
      const result = await cepPromise(cep)
      return !!result.cep
    },
    setData(data) {
      this.endereco = {
        ...this.endereco,
        ...data,
      }
    },
    returnData() {
      this.$v.$touch()

      return {
        data: { ...this.form },
        validation: !this.$v.$invalid && !this.cepError.has,
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
